function createHasOwn() {
  if (Object.hasOwn) return Object.hasOwn
  return function hasOwn(object: object, key: PropertyKey): boolean {
    return Object.prototype.hasOwnProperty.call(object, key)
  }
}

const internalHasOwn = createHasOwn()

export function hasOwn(object: object, key: PropertyKey): boolean {
  if (object === undefined || object === null) return false
  return internalHasOwn(object, key)
}
